<template>
  <div class="contents-list">
    <template v-if="contents && contents.length > 0">
      <!-- <div class="filters-panel">
        <form class="search-form">
          <input type="text" placeholder="Search Contents" />
        </form>
      </div> -->
      <ul class="list-container">
        <li
          v-for="content in contents"
          :key="content.id"
          :class="`content clickable type-${content.type}`"
          @click="() => onEditContent(content.id, content.type)"
        >
          <div class="content-thumbnail">
            <img
              :src="
                content.thumbnailUrl ? content.thumbnailUrl : images.picture
              "
              :alt="content.title"
            />
          </div>
          <div class="content-detail">
            <h4 class="content-title">
              {{ (content.title || "") | truncate(titleLength) }}
            </h4>
            <div class="content-description">
              {{ (content.description || "") | truncate(descriptionLength) }}
            </div>
            <div class="content-whitespace" />
            <div class="content-hashtag">
              {{
                (content.socialIdentifiers || "")
                  | truncate(socialIdentifiersLength)
              }}
            </div>
          </div>
          <div class="content-meta">
            <div
              class="content-attribute"
              v-if="
                content.orderedCategories &&
                content.orderedCategories.length > 0
              "
            >
              <div class="content-attribute-label">Categories:</div>
              <div class="content-attribute-value">
                {{ getOrderedCategories(content.orderedCategories) }}
              </div>
            </div>
            <div
              class="content-attribute"
              v-if="content.country || content.region || content.district"
            >
              <div class="content-attribute-label">Location:</div>
              <div class="content-attribute-value">
                {{ getLocationList(content) }}
              </div>
            </div>
            <div
              class="content-attribute"
              v-if="
                content.experiences &&
                content.experiences.results &&
                content.experiences.results.length > 0
              "
            >
              <div class="content-attribute-label">Affiliations:</div>
              <div class="content-attribute-value">
                <carousel controls>
                  <slide
                    v-for="(exp, index) of content.experiences.results"
                    :key="index"
                  >
                    <a
                      href="javascript:void(0);"
                      :title="exp.title"
                      class="block-item"
                      :class="{ 'no-img': !exp.thumbnailUrl }"
                    >
                      <template v-if="exp.thumbnailUrl">
                        <img :src="exp.thumbnailUrl" :alt="exp.title" />
                      </template>
                      <template v-else>
                        {{ exp.title }}
                      </template>
                    </a>
                  </slide>
                </carousel>
              </div>
            </div>
            <div
              class="content-attribute"
              v-if="
                content.platforms &&
                content.platforms.results &&
                content.platforms.results.length > 0
              "
            >
              <div class="content-attribute-label">Distribution:</div>
              <div class="content-attribute-value">
                <carousel :paginationEnabled="false" :perPage="6">
                  <slide
                    v-for="(platform, index) of content.platforms.results"
                    :key="index"
                  >
                    <a
                      href="javascript:void(0);"
                      :title="platform.name"
                      class="block-item"
                      :class="{ 'no-img': !platform.thumbnailUrl }"
                    >
                      <template v-if="platform.thumbnailUrl">
                        <img
                          :src="platform.thumbnailUrl"
                          :alt="platform.name"
                        />
                      </template>
                      <template v-else>
                        {{ platform.name }}
                      </template>
                    </a>
                  </slide>
                </carousel>
              </div>
            </div>
            <div class="content-whitespace" />
            <div class="content-updated-time">
              Last updated {{ getReadableDatetime(content.updatedAt) }}
            </div>
          </div>
          <div :class="`content-status status-${content.status}`">
            <img
              :src="
                content.status === 'publish'
                  ? images.publishIcon
                  : images.editIcon
              "
            />
          </div>
        </li>
      </ul>
    </template>

    <div v-else class="empty-results">
      <p>{{ emptyText }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import publishIcon from "@/assets/images/publish-icon.svg";
import editIcon from "@/assets/images/edit-icon.svg";
import picture from "@/assets/images/picture.svg";
import ItemAttributes from "./AffiliationPicker/ItemAttributes.vue";

export default {
  components: { ItemAttributes },
  props: {
    titleLength: {
      type: Number,
      default: 100,
    },
    descriptionLength: {
      type: Number,
      default: 200,
    },
    socialIdentifiersLength: {
      type: Number,
      default: 100,
    },
    types: {
      type: Array,
      default() {
        return [];
      },
    },
    search: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default:
        "This account has no experience yet. Please press the ADD button above.",
    },
  },
  data() {
    return {
      images: {
        publishIcon,
        editIcon,
        picture,
      },
      contents: [],
      next: "",
      nextToken: "",
      limit: 10,
    };
  },
  apollo: {
    userContents: {
      query: require("../graphql/queries/userContents.gql"),
      variables() {
        return {
          limit: this.limit,
          next: this.next,
          types: this.types,
          search: this.search,
        };
      },
      result({ data }) {
        const { results, next, hasNext } = data.userContents;
        this.contents = this.contents.concat(results);
        this.nextToken = next;
      },
      fetchPolicy: "network-only",
    },
  },
  methods: {
    loadmore() {
      this.next = this.nextToken;
    },
    reload() {
      this.clear();
      this.$apollo.queries.userContents.refetch();
    },
    clear() {
      this.next = "";
      this.nextToken = "";
      this.contents = [];
    },
    onEditContent(id, type) {
      this.$emit("edit", id, type);
    },
    getReadableDatetime(time) {
      return moment(time).fromNow();
    },
    getOrderedCategories(categories) {
      return categories.map((it) => it.title).join(" | ");
    },
    getLocationList(item) {
      const list = [];
      if (item.country) {
        list.push(item.country.title);
      }
      if (item.region) {
        list.push(item.region.title);
      }
      if (item.district) {
        list.push(item.district.title);
      }
      return list.join(" | ");
    },
  },
};
</script>

<style scoped lang="scss">



@media only screen and (min-width: $breakpoint-tablet-ipad){
  .contents-list {
    padding-bottom: 50px;
    .filters-panel {
      margin: 30px 0;
      display: flex;
      justify-content: flex-end;
    }

    .empty-results {
      margin: 100px auto 0;
    }

    .list-container {
      list-style: none;
      padding: 0;
      .content {
        display: flex;
        min-height: 250px;
        background-color: #fff;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        border-left: 25px solid gray;
        color: black;

        .content-thumbnail {
          width: 18%;
          flex: 0 0 auto;

          img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
            object-position: center;
          }
        }

        .content-detail {
          flex: 1 1 auto;
          padding: 20px 10px 20px 20px;
          display: flex;
          flex-direction: column;
        }

        .content-title {
          font-size: 1.125rem;
          font-weight: 400;
        }

        .content-description {
          font-size: 0.75rem;
          font-weight: 400;
        }

        .content-hashtag {
          font-size: 1.125rem;
          font-weight: 400;
        }

        .content-meta {
          font-size: 0.75rem;
          width: 35%;
          padding: 20px 20px 20px 10px;
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
        }

        .content-attribute {
          display: flex;
          margin-top: 5px;

          .content-attribute-label {
            font-weight: bold;
            flex: 0 0 auto;
            margin-right: 5px;
            min-width: 80px;
          }

          .VueCarousel {
            .VueCarousel-slide {
              & + .VueCarousel-slide {
                margin-left: 5px;
              }
              .block-item {
                display: block;
                width: 25px;
                height: 25px;
                text-indent: -99999px;
                &.no-img {
                  background-color: #1da1f2;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  object-position: center;
                  display: block;
                }
              }
            }
          }
        }

        .content-whitespace {
          flex: 1 1 auto;
        }

        .content-updated-time {
          color: var(--color-light-gray);
          font-size: 0.8125rem;
        }

        .content-status {
          width: 40px;
          background-color: #58595b;
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          &.status-publish {
            background-color: var(--primary-color);
          }
        }

        &.type-experience {
          border-left-color: var(--experience-color);
        }

        &.type-tour {
          border-left-color: var(--tour-color);
        }

        &.type-event {
          border-left-color: var(--event-color);
        }

        &.type-offer {
          border-left-color: var(--offer-color);
        }

        &.type-campaign {
          border-left-color: var(--campaign-color);
        }
        &.type-story {
          border-left-color: var(--story-color);
        }
      }

      .content + .content {
        margin-top: 30px;
      }
    }
  }
}

@media only screen and (max-width: $breakpoint-phone) {
  .list-container {
    padding-left: 0;
    .content {
      margin-top: 5%;
      min-height: 250px;
      background-color: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      border-top: 25px solid gray;
      color: black;

      .content-thumbnail {
        width: 100%;
        max-height: 80%;
        flex: 0 0 auto;

        img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          object-position: center;
        }
      }

      .content-detail {
        flex: 1 1 auto;
        padding: 20px 10px 0 10px;
        display: flex;
        flex-direction: column;
      }

      .content-title {
        font-size: 1.125rem;
        font-weight: 400;
      }

      .content-description {
        font-size: 0.75rem;
        font-weight: 400;
      }

      .content-hashtag {
        font-size: 1.125rem;
        font-weight: 400;
      }

      .content-meta {
        font-size: 0.75rem;
        width: 100%;
        padding: 20px 20px 20px 10px;
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
      }

      .content-attribute {
        display: flex;
        // margin-top: 5px;

        .content-attribute-label {
          font-weight: bold;
          flex: 0 0 auto;
          margin-right: 5px;
          min-width: 80px;
        }

        .VueCarousel {
          .VueCarousel-slide {
            & + .VueCarousel-slide {
              margin-left: 5px;
            }
            .block-item {
              display: block;
              width: 25px;
              height: 25px;
              text-indent: -99999px;
              &.no-img {
                background-color: #1da1f2;
              }
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
                display: block;
              }
            }
          }
        }
      }

      .content-whitespace {
        flex: 1 1 auto;
      }

      .content-updated-time {
        color: var(--color-light-gray);
        font-size: 0.8125rem;
      }

      .content-status {
        text-align: center;
        width: 100%;
        background-color: #58595b;
        flex: 0 0 auto;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &.status-publish {
          background-color: var(--primary-color);
        }
      }

      &.type-experience {
        border-top-color: var(--experience-color);
      }

      &.type-tour {
        border-top-color: var(--tour-color);
      }

      &.type-event {
        border-top-color: var(--event-color);
      }

      &.type-offer {
        border-top-color: var(--offer-color);
      }

      &.type-campaign {
        border-top-color: var(--campaign-color);
      }
      &.type-story {
        border-top-color: var(--story-color);
      }
    }
  }
}
</style>
